import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { ItemResponseWrapper } from 'src/app/shared/http.types';
import { environment } from 'src/environments/environment';

export interface IPatron {
  avatar: string,
  avatarUrl?: string,
  email: string,
  firstName: string,
  id: string,
  lastName: string,
  phone: string,
}

@Injectable({
  providedIn: 'root',
})
export class PatronService {
  constructor(
    private http: HttpClient
  ) {}

  public getPatronByAccount(id: string) {
    return this.http
      .get<ItemResponseWrapper<IPatron>>(`${environment.backendBaseUrl}/patron/account/${id}`)
      .pipe(
        map(value => {
          const partner = value.data;

          return {
            data: partner,
          };
        })
      );
  }
}
